import {
  getAdmins,
  getRoles,
  createAdmin,
  updateAdmin,
  resendAdminEmail,
  deleteAdmin,
} from '../../shared/services/apiService';

// ── Load admins and roles in parallel ────────────────────────────────────────
export const loadAdminsData = async () => {
  const [aRes, rRes] = await Promise.all([getAdmins(), getRoles()]);
  return {
    admins: aRes.data.data.admins,
    roles:  rRes.data.data.roles,
  };
};

// ── Create a new sub-admin (returns created admin info) ──────────────────────
export const addAdmin = async (formData) => {
  const res = await createAdmin(formData);
  return res.data.data;
};

// ── Update admin fields (role, active status, etc.) ──────────────────────────
export const editAdmin = async (id, payload) => {
  await updateAdmin(id, payload);
};

// ── Resend credentials email ──────────────────────────────────────────────────
export const resendEmail = async (id) => {
  await resendAdminEmail(id);
};

// ── Delete admin permanently ──────────────────────────────────────────────────
export const removeAdmin = async (id) => {
  await deleteAdmin(id);
};
